import React from "react";

export const LegendPill: React.FC<{ color: string; label: string }> = ({ color, label }) => (
  <div
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
      padding: "6px 10px",
      borderRadius: 999,
      background: "rgba(255,255,255,0.92)",
      boxShadow: "0 6px 18px rgba(0,0,0,0.18)",
      border: "1px solid rgba(15,23,42,0.12)",
      fontSize: 12,
      fontWeight: 600,
      color: "#0f172a",
      whiteSpace: "nowrap",
      pointerEvents: "none",
    }}
  >
    <span
      aria-hidden
      style={{
        width: 10,
        height: 10,
        borderRadius: 999,
        background: color,
        boxShadow: "0 0 0 2px rgba(255,255,255,0.9)",
      }}
    />
    {label}
  </div>
);

export const JourneyLegend: React.FC = () => (
  <div
    style={{
      background: "rgba(255,255,255,0.42)",
      backdropFilter: "blur(6px)",
      borderRadius: 14,
      padding: "6px 12px",
      boxShadow: "0 6px 18px rgba(0,0,0,0.18)",
      border: "1px solid rgba(15,23,42,0.12)",
      display: "flex",
      flexDirection: "column",
      gap: 6,
      alignItems: "center",
    }}
  >
    <span
      style={{
        fontSize: 12,
        fontWeight: 700,
        color: "#0f172a",
        opacity: 0.85,
        pointerEvents: "none",
      }}
    >
      Congestion
    </span>

    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", justifyContent: "center" }}>
      <LegendPill color="#22c55e" label="Low" />
      <LegendPill color="#eab308" label="Moderate" />
      <LegendPill color="#f97316" label="Heavy" />
      <LegendPill color="#ef4444" label="Severe" />
    </div>
  </div>
);
